import { useContext } from "react";
import { ROUTES, zenvolyaNewLogo } from "../../../constant";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../constant/google-analytics/GAEvents";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import Login from "../login/login";
import ProfileMenu from "../../home&Landingpage/desktopLandingPage/avatar/avatar";
import styles from "./nav.module.scss";
import { useNavigationUrl } from "../../../hooks/useNavigationUrl";

interface iNavbarProps {
  // Optional overrides for the logo / Login actions. Defaults keep the normal
  // in-app behavior (client-side nav + login modal). The maintenance/CORS-error
  // screen passes hard-reload handlers because a client-side nav can't escape
  // its latched IS_CORS_ERROR gate. See App.tsx maintenance branch + login.tsx.
  onLogoClick?: () => void;
  onLoginClick?: () => void;
}

function Navbar({ onLogoClick, onLoginClick }: iNavbarProps = {}): JSX.Element {
  // const navigate = useNavigate();
  const { navigateWithParams } = useNavigationUrl();
  const context = useContext(StateContext);
  const { setScreen, userInfo, setFirstScreen }: iGlobalContext = context;
  const handleLogoClick = () => {
    triggerGAEvent(GA_LABEL_ENUMS.home_zenvoya_logo_click);
    if (onLogoClick) {
      onLogoClick();
      return;
    }
    navigateWithParams(ROUTES.Home);
    setScreen("");
    setFirstScreen("");
  };

  return (
    <div className={styles.main}>
      <img className={styles.logo} alt="logo" src={zenvolyaNewLogo} onClick={handleLogoClick} />
      {userInfo?.loggedIn === true ? <ProfileMenu /> : <Login closeDrawer={() => {}} onLoginClick={onLoginClick} />}
    </div>
  );
}

export default Navbar;
